import { CoreInitiativesByIdName } from './name';
import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteInitiativeById } from '@api';

export const coreInitiativesByIdDeleteAsyncSlice = createDeleteAsyncSlice({
	name: CoreInitiativesByIdName,
	receive: false,
	request: true,
	requestHandler: deleteInitiativeById
});
